import React, { ReactNode, useState } from "react";
import { Menu, MenuItem, Box } from "@material-ui/core";
import { useStyles } from "../style";
import MessageIcon from "../../../../components/Icons/MessageIcon";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

interface MenuItemType {
  label: string;
  onClick: (event: React.MouseEvent<HTMLLIElement>) => void;
  className?: string;
}

const invertColor = (hex: string) => {
  let col = (hex || "#ffffff").replace(/^#/, "");
  if (col.length === 3) col = col.split("").map((c) => c + c).join("");
  const num = parseInt(col || "ffffff", 16);
  const r = 255 - ((num >> 16) & 0xff);
  const g = 255 - ((num >> 8) & 0xff);
  const b = 255 - (num & 0xff);
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
};

const ChannelMenu = ({ menuItems, source = "channel", settings = null }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const authInfo = JSON.parse(localStorage.getItem("authInfo"));

  // 🎨 pull community theme (colors only)
  const singleProgram = useSelector((state: RootState) => state.programReducer.singleProgram);
  const { communityIdentifier } = JSON.parse(localStorage.getItem("activeProgramEnrollment") || "{}");
  const communityTheme = React.useMemo(() => {
    const community = singleProgram?.communities?.find(
      (c: any) => c?.communityIdentifier === communityIdentifier
    );
    return {
      mainColor: community?.communityStyle?.mainColor || "#1976d2",
      secondaryColor: community?.communityStyle?.secondaryColor || "#ffffff",
      fontStyle: community?.communityStyle?.fontStyle || "Arial",
    };
  }, [singleProgram, communityIdentifier]);
  const fgOnSecondary = React.useMemo(
    () => invertColor(communityTheme.secondaryColor),
    [communityTheme.secondaryColor]
  );

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: React.MouseEvent) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <Box
      style={{ marginLeft: "10px", cursor: "pointer", color: communityTheme.mainColor }}
      onClick={handleClick}
    >
      {source === "post" ? (
        <span style={{ color: communityTheme.mainColor }}>
          <MessageIcon />
        </span>
      ) : (
        <h1 className={classes.channelTitle} style={{ color: communityTheme.mainColor }}>
          ⋮
        </h1>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          style: {
            backgroundColor: communityTheme.secondaryColor,
            color: fgOnSecondary,
            fontFamily: communityTheme.fontStyle,
          },
        }}
      >
        {menuItems?.map((item: MenuItemType, index: number) => (
          <MenuItem
            key={index}
            onClick={(event) => {
              if (item.onClick) {
                item?.onClick(event);
                handleClose(event);
              }
            }}
            className={`${item.className ? classes.activeItem : ""}`}
            style={{
              color: fgOnSecondary,
              fontFamily: communityTheme.fontStyle,
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default ChannelMenu;
